// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type GetCareerHubTopicArticleQueryVariables = Types.Exact<{
  globalId: Types.Scalars['GlobalID']['input'];
}>;

export type GetCareerHubTopicArticleQuery = {
  __typename?: 'Query';
  articleByGlobalId?: {
    __typename?: 'ArticlesArticle';
    id: string;
    content?: any | null;
  } | null;
};

export const GetCareerHubTopicArticleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCareerHubTopicArticle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'globalId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GlobalID' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'articleByGlobalId' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'globalId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'globalId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCareerHubTopicArticleQuery,
  GetCareerHubTopicArticleQueryVariables
>;
